import { appEnv } from '../lib/env';

export function UnsubscribedPage() {
  return (
    <div className="main-container" id="unsubscribe-complete">
      <div className="main-container-top">
        <h2>Email Confirmation Complete</h2>
        <p className="main-text">Your email address has been successfully unsubscribed.</p>
      </div>
      <a href={appEnv.logoFrontendUrl} className="btn-link">
        <button className="secondary">
          <span />
          <span>HOME</span>
          <img src="/assets/arrow_right.svg" alt="" width="24" height="24" />
        </button>
      </a>
    </div>
  );
}
